import get from 'lodash-es/get';
import defaultsDeep from 'lodash-es/defaultsDeep';
import each from 'lodash-es/each';
import panel from './controls/panel';
import textInput from './controls/textInput';
import range from './controls/range';
import label from './controls/label';
import splitter from './controls/splitter';
import splitPane from './controls/splitPane';
import button from './controls/button';
import reloadButton from './controls/reloadButton';
import colorPicker from './controls/colorPicker';
import icon from './controls/icon';
import callout from './controls/callout';
import checkbox from './controls/checkbox';
import switchCtrl from './controls/switch';
import radiobutton from './controls/radiobutton';
import combobox from './controls/combo';
import choices from './controls/choices';
import toolbar from './controls/toolbar';
import frame from './controls/frame';
import ticker from './controls/ticker';
import layoutContainer from './controls/layoutContainer';
import overlay from './controls/overlay';
import grid from './controls/grid';
import progress from './controls/progress';
import dropBox from './controls/dropBox';
import contextMenu from './controls/contextMenu';
import audio from './controls/audio';
import video from './controls/video';
import recorder from './controls/recorder';
import transcriber from './controls/transcriber';
import audioRecorder from './controls/audioRecorder';

var controlTypes = {
  label,
  splitter,
  panel,
  textInput,
  range,
  button,
  reloadButton,
  colorPicker,
  icon,
  callout,
  checkbox,
  switch: switchCtrl,
  radiobutton,
  combobox,
  choices,
  toolbar,
  frame,
  ticker,
  layoutContainer,
  grid,
  overlay,
  progress,
  dropBox,
  contextMenu,
  splitPane,
  audio,
  video,
  recorder,
  transcriber,
  audioRecorder
};

export function renderControl(instance, ctrlOptions, ctrlPath,ctrlNicePath,parentControl,parentElement){
  
    if (!instance.controls[ctrlPath]) {
      // let type = get(instance.options, ctrlPath);
      // const ctrlNicePath = (nicePath?(nicePath+' / '):'')+type.type+(type.name?' '+type.name+'':'');
      let type = ctrlOptions && ctrlOptions.type;
      if (controlTypes[type]) {
        instance.controls[ctrlPath] = new controlTypes[type](instance, ctrlPath, ctrlNicePath);
        instance.controls[ctrlPath].type = type;
        instance.controls[ctrlPath].parentControl = parentControl;
      }
    } else if (ctrlOptions === null) {
      // console.log('destroy');
      instance.controls[ctrlPath].destroy();
      delete instance.controls[ctrlPath];
      if (parentControl && parentControl.childrenControls[ctrlPath]) {
        delete parentControl.childrenControls[ctrlPath];
      }

      return;
    }

    const parentLookAndFeel = parentControl && parentControl.options.lookAndFeel || instance.options.lookAndFeel;
    ctrlOptions.lookAndFeel = defaultsDeep(ctrlOptions.lookAndFeel,parentLookAndFeel,{controlsDesign:'classic'});
    if(ctrlOptions && ctrlOptions.$renderOnTop) {parentElement = null;}

    let el = parentElement  || instance.args.element;
    if (_.isFunction(parentElement)) {
      el = parentElement(instance.controls[ctrlPath]);
    }

    if (parentControl && instance.controls[ctrlPath]) {
      instance.controls[ctrlPath].parentControl = parentControl;
      if(!parentControl.childrenControls){
        parentControl.childrenControls={};
      }

      parentControl.childrenControls[ctrlPath] = instance.controls[ctrlPath];
    }

    instance.controls[ctrlPath] && instance.controls[ctrlPath].render(null, el);
}

export function renderControls(instance, path='', nicePath='', parentElement) {
  // console.log('renderControls', instance.options, path);
  // console.time('render controls at ' + path);
  instance.fire('beforeRenderControls');
  const controlsOptions = path
    ? _.get(instance.options, path)['controls']
    : instance.options.controls;
  // const parentControl = instance.controls[path.replace(/\.contextMenu$/,'')];
  const parentControl = instance.controls[path];
  if (parentControl && !parentControl.childrenControls) {
    parentControl.childrenControls = {};
  }

  const isArray = Array.isArray(controlsOptions);
  each(controlsOptions, (co, i) => {
    const key = isArray ? i : `"${i}"`;
    var ctrlPath = (path ? path + '.' : '') + 'controls[' + key + ']';
    // let type = get(instance.options, ctrlPath);
    const ctrlNicePath = (nicePath?(nicePath+' / '):'')+(co && co.type)+((co&&co.name)?' '+co.name+'':'');    
    renderControl(instance, co, ctrlPath, ctrlNicePath, parentControl, parentElement);
  });
  // console.timeEnd('render controls at ' + path);
  instance.fire('renderControls');
  return parentElement;
}

// updateClass(
//   'io-controls-default-style',
//   [
//     {
//       selector: '&>div.body>*:hover',
//       properties: {
//         zIndex: '100500!important',
//       },
//     },
//   ],
//   '.io-controls'
// );
